import React, { useState } from 'react';
import { Card, Typography, Breadcrumb, Input, Row, Col, List, Space, Button, Spin } from 'antd';
import Background from '../../../../static/img/bg-list-title.png';
import { queryFeedbackConfigList } from './gqls'
import Client from '../../../../lib/gqlClient';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
const ClassificationManagement = (props) => {
    const navigate = useNavigate();
    const [seatchData, setSeatchData] = useState('')
    const [isGetData, setIsGetData] = useState(false)
    const [total, setTotal] = useState(1)
    const [dataList, setDataList] = useState([])
    const { Paragraph, Text } = Typography;
    const [level2List, setLevel2List] = useState([""]);
    const [modelList, setModelList] = useState([""]);
    const [showSize, setShowSize] = useState(8)
    React.useEffect(() => {
        onSearch()
    }, [])
    function onInPut(value) {
        console.log(value.target.value);
        setSeatchData(value.target.value)
    }     
    function onSearch() {
        getFeedbackConfigList(seatchData, 1,showSize)
    }
    function getFeedbackConfigList(value, page,count) {
        setIsGetData(true)
        if(count!==showSize){
            setShowSize(count)
        }
        Client(queryFeedbackConfigList,
            {
                name: value,
                page: page,
                count: count
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                let list = [""];
                let listModel = [""];
                res.data.feedbackConfigList.data.map((item, index) => {
                    let level2 = ''
                    item.subLevel.map((item2, index2) => {
                        if (level2 === "") {
                            level2 = item2.display
                        } else {
                            level2 = level2 + "\n" + item2.display
                        }

                    })
                    list[index] = level2
                    const model = item.deviceModel
                    listModel[index] = model.replace(/,/g, '\n')

                })
                setLevel2List(list)
                setModelList(listModel)
                setDataList(res.data.feedbackConfigList.data)
                setTotal(res.data.feedbackConfigList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            setIsGetData(false)
        })
    }

    function onStart() {
        props.setNewKey('developerCenter/dataNotification')
        navigate('/developerCenter/dataNotification')

    }
    return (
        <div style={{ height: '100%', width: '100%', }}>

            {/* 标题头 */}
            <div style={{ height: '200px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>Feedback</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>分类管理</a></Breadcrumb.Item>
                </Breadcrumb>
                <div style={Styles.title}>搜索分类</div>

                <Row style={Styles.search}>
                    <Col>
                        <div >
                            <Input
                                placeholder="请输入 Level1 name"
                                size="large"
                                maxLength="10"
                                style={{
                                    width: '556px',
                                    borderRadius: '2px',
                                    height: '46px'
                                }}
                                onChange={onInPut}
                                onPressEnter={onSearch}
                            />
                        </div></Col>
                    <Col>
                        <Button style={{ padding: '0px', height: '46px', width: '80px', background: '#FF5300', color: 'white' }} onClick={onSearch}>搜索</Button>
                    </Col>
                </Row>

            </div>


            <Card bordered={false} style={{ marginTop: '25px', marginBottom: '25px', padding: '0px', }}>
                <div style={Styles.listTitle}>反馈列表</div>
                <Row style={Styles.listTitleBg}>
                    <Col span={3} style={Styles.listTitleText}>
                        ID
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Level1 name
                    </Col>
                    <Col span={3} style={Styles.listTitleText}>
                        Issue Type
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Level2 name
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Device Model
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Create Time
                    </Col>
                    <Col span={2} style={Styles.listTitleText}>
                        Operation
                    </Col>
                </Row>
                <Spin size="large" tip="Loading..." spinning={isGetData}>

                    <List
                        itemLayout="vertical"
                        split="true"
                        pagination={{
                            onChange: (page) => {
                                getFeedbackConfigList(seatchData, page,showSize)
                            },
                            pageSize: showSize,
                            hideOnSinglePage: true,
                            pageSizeOptions:[8,10,15,20,30,50,80,100],
                            onShowSizeChange: (current, pageSize) => {
                                getFeedbackConfigList(seatchData, current,pageSize)
                            },
                            total: total

                        }}
                        position="bottom"
                        dataSource={dataList}
                        renderItem={(item, index) => (
                            <List.Item>
                                <Row style={Styles.item}>
                                    <Col span={3} style={Styles.listTitleText}>
                                        {item.id}
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        <Paragraph
                                            ellipsis={{
                                                symbol: 'more',
                                            }}
                                        >{item.level1Name}</Paragraph>
                                    </Col>
                                    <Col span={3} style={Styles.listTitleText}>
                                        {item.issueType}
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        <Paragraph
                                            style={{ whiteSpace: 'pre-line' }}
                                            ellipsis={{
                                                symbol: 'more',
                                            }}
                                        >{level2List[index]}</Paragraph>
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        <Paragraph
                                            style={{ whiteSpace: 'pre-line' }}
                                            ellipsis={{
                                                symbol: 'more',
                                            }}
                                        >{modelList[index]}</Paragraph>
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        {item.createdAt.substring(0, 10) + " " + item.createdAt.substring(11, 19)}
                                    </Col>
                                    <Col span={2} style={{
                                        fontSize: '14px',
                                        paddingLeft: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'left',
                                        color: 'rgba(0, 0, 0, 0.2)'
                                    }}>
                                        <div aria-disabled>View</div>
                                    </Col>
                                </Row>
                            </List.Item>
                        )}
                    />
                </Spin>
            </Card>

        </div>
    );

}

const { Search } = Input;
const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
    search: {
        color: '#2D3238',
        height: '46px',
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'

    },
    listTitleBg: {
        height: '54px',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        marginTop: '30px'
    },
    listTitleText: {
        fontSize: '14px',
        paddingLeft: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginBottom: '0px',
        marginTop: '0px',
    },
    item: {

        padding: '0px',
        margin: '0px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
    },
}
export default ClassificationManagement